import { saveAs } from "file-saver";

export const onButtonClick = () => {
  window.open =
    "https://drive.google.com/file/d/1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U/view?usp=sharing";
  //   saveAs(
  //     "https://drive.google.com/u/0/uc?id=1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U&export=download"
  //   );
  window.location.href =
    "https://drive.google.com/u/0/uc?id=1sz41DUZj0qrHWskFS5tUz-EgVhnjiD1U&export=download";
};
